module.exports = __webpack_public_path__ + "img/bannerHome1.af2124cb.webp";